import Sphero from 'sphero-sdk/sphero/ChromeSphero';
import { getToyboxWorkerUrl } from './toyboxWorkerAsset';

/** Matches sphero-sdk-utils/Utilities.LogLevel (used by SDK and toybox worker). */
const LogLevel = { OFF: 0, INFO: 1, DEBUG: 2, VERBOSE: 3 };

// Import the worker as a built asset so Vite serves the copy from the installed SDK package.
const getWorkerPath = () => getToyboxWorkerUrl();

const SpheroSDK = async (options) => {
  let sdk = null;

  sdk = new Sphero({
    ...options,
    workerPath: getWorkerPath(),
    toyPutAwayEventDelayMs: 250,
    logLevel: LogLevel.INFO,
  });
  await sdk.init();
  sdk.disableStats();

  delete sdk.getBluetoothState;

  return sdk;
};

export default SpheroSDK;
